// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2EccR","col":"Table_col__3htSW","fulfillmentStatus":"Table_fulfillmentStatus__1IFBI","emailCol":"Table_emailCol__1xFNq"};